import { useLanguage } from '../contexts/LanguageContext';

const FAQSchema: React.FC = () => {
  const { language } = useLanguage();
  
  const faqData = {
    fr: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Quels services proposez-vous aux frontaliers ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nous accompagnons les frontaliers France-Allemagne dans toutes leurs démarches : déclarations fiscales, inscription santé (carte vitale, CAF), prestations familiales (Elterngeld, Kindergeld), immatriculation véhicule, retraite transfrontalière et bien plus."
          }
        },
        {
          "@type": "Question",
          "name": "Comment se passe la déclaration d'impôts pour un frontalier ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Les frontaliers doivent souvent déclarer dans les deux pays. Nous analysons votre situation personnelle pour optimiser votre déclaration et éviter la double imposition grâce aux conventions fiscales franco-allemandes."
          }
        },
        {
          "@type": "Question",
          "name": "Combien coûtent vos prestations ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nos tarifs varient selon la complexité de votre dossier. Nous proposons une première consultation gratuite pour évaluer vos besoins et vous donner un devis personnalisé sans engagement."
          }
        },
        {
          "@type": "Question",
          "name": "Dans quelle région intervenez-vous ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Nous intervenons principalement dans le Grand-Est (Alsace, Lorraine, Moselle) pour les frontaliers travaillant en Allemagne (Bade-Wurtemberg, Rhénanie-Palatinat, Sarre)."
          }
        }
      ]
    },
    de: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Welche Dienstleistungen bieten Sie für Grenzgänger an?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Wir begleiten Grenzgänger Deutschland-Frankreich bei allen Formalitäten: Steuererklärungen, Krankenversicherung (Carte Vitale, CAF), Familienleistungen (Elterngeld, Kindergeld), Fahrzeugzulassung, grenzüberschreitende Rente und vieles mehr."
          }
        },
        {
          "@type": "Question",
          "name": "Wie funktioniert die Steuererklärung für Grenzgänger?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Grenzgänger müssen oft in beiden Ländern erklären. Wir analysieren Ihre persönliche Situation, um Ihre Erklärung zu optimieren und Doppelbesteuerung durch deutsch-französische Steuerabkommen zu vermeiden."
          }
        },
        {
          "@type": "Question",
          "name": "Wie viel kosten Ihre Dienstleistungen?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Unsere Preise variieren je nach Komplexität Ihres Falls. Wir bieten eine kostenlose Erstberatung an, um Ihren Bedarf zu bewerten und Ihnen ein unverbindliches Angebot zu machen."
          }
        },
        {
          "@type": "Question",
          "name": "In welcher Region sind Sie tätig?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Wir sind hauptsächlich im Großraum Ostfrankreich (Elsass, Lothringen, Mosel) für Grenzgänger tätig, die in Deutschland arbeiten (Baden-Württemberg, Rheinland-Pfalz, Saarland)."
          }
        }
      ]
    }
  };

  const schema = faqData[language as 'fr' | 'de'] || faqData.fr;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default FAQSchema;
